import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSponsorsApi,
  createSponsorApi,
  getSponsorDetailsApi,
  assignStaffToSponsorApi,
  assignSponsorLocationApi,
  removeSponsorLocationApi,
  getSponsorQuotaApi,
} from "./sponsorApi";

export const getSponsors = createAsyncThunk(
  "sponsor/get",
  async ({ page, limit, search }, thunkAPI) => {
    try {
      const res = await getSponsorsApi({ page, limit, search });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const createSponsor = createAsyncThunk(
  "sponsor/create",
  async (data, thunkAPI) => {
    try {
      const res = await createSponsorApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);
export const assignStaffToSponsor = createAsyncThunk(
  "sponsor/assignStaff",
  async (data, thunkAPI) => {
    try {
      const res = await assignStaffToSponsorApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const getSponsorDetails = createAsyncThunk(
  "sponsor/details",
  async (id, thunkAPI) => {
    try {
      const res = await getSponsorDetailsApi(id);
      return { id, data: res.data.data };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const assignSponsorLocation = createAsyncThunk(
  "sponsor/assignLocation",
  async (data, thunkAPI) => {
    try {
      const res = await assignSponsorLocationApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const removeSponsorLocation = createAsyncThunk(
  "sponsor/removeLocation",
  async (data, thunkAPI) => {
    try {
      const res = await removeSponsorLocationApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const getSponsorQuota = createAsyncThunk(
  "sponsor/quota",
  async (sponsorId, thunkAPI) => {
    try {
      const res = await getSponsorQuotaApi(sponsorId);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const slice = createSlice({
  name: "sponsor",
  initialState: {
    sponsors: [],
    sponsorDetails: {},
    loggedInSponsorQuota: null,
    total: 0,
    loading: false,
    ssignLoading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSponsors.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSponsors.fulfilled, (state, action) => {
        state.loading = false;
        state.sponsors = action.payload.items || [];
        state.total = action.payload.total || 0;
      })
      .addCase(assignStaffToSponsor.pending, (state) => {
        state.assignLoading = true;
      })
      .addCase(assignStaffToSponsor.fulfilled, (state) => {
        state.assignLoading = false;
      })
      .addCase(assignStaffToSponsor.rejected, (state) => {
        state.assignLoading = false;
      })
      .addCase(getSponsorDetails.fulfilled, (state, action) => {
        state.sponsorDetails[action.payload.id] = action.payload.data;
      })
      .addCase(assignSponsorLocation.fulfilled, (state, action) => {
        const { userId, locationId } = action.meta.arg;
        const sponsor = state.sponsors.find((item) => item.id === userId);
        const location =
          sponsor?.eventLocations?.find((item) => item.id === locationId) ||
          sponsor?.EventLocations?.find((item) => item.id === locationId) ||
          sponsor?.locations?.find((item) => item.id === locationId);

        if (sponsor && !location) {
          const assignedLocation = action.payload?.data?.location || action.payload?.data;
          const currentLocations = sponsor.eventLocations || sponsor.EventLocations || sponsor.locations || [];
          sponsor.eventLocations = [
            ...currentLocations,
            assignedLocation?.id ? assignedLocation : { id: locationId, name: assignedLocation?.name || "" },
          ];
        }
      })
      .addCase(removeSponsorLocation.fulfilled, (state, action) => {
        const { userId, locationId } = action.meta.arg;
        const sponsor = state.sponsors.find((item) => item.id === userId);

        if (sponsor) {
          const currentLocations = sponsor.eventLocations || sponsor.EventLocations || sponsor.locations || [];
          sponsor.eventLocations = currentLocations.filter((item) => item.id !== locationId);
        }
      })
      .addCase(getSponsorQuota.fulfilled, (state, action) => {
        state.loggedInSponsorQuota = action.payload;
      })
      .addCase(createSponsor.fulfilled, () => { });

  },
});

export default slice.reducer;
